let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eHaGV")).then(() => parcelRequire('hP3VP'));